const DEFAULT_TIME_ZONE = 'Asia/Shanghai'

function parseApiDateTime(value: string): Date | null {
  const trimmed = value.trim()
  if (!trimmed) return null

  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(trimmed)
  const normalized = hasTimezone ? trimmed : `${trimmed}Z`
  const date = new Date(normalized)

  return Number.isNaN(date.getTime()) ? null : date
}

function getDateTimeParts(date: Date, timeZone: string) {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })

  const parts = Object.fromEntries(
    formatter.formatToParts(date).map((part) => [part.type, part.value]),
  )

  return {
    year: parts.year,
    month: parts.month,
    day: parts.day,
    hour: parts.hour === '24' ? '00' : parts.hour,
    minute: parts.minute,
    second: parts.second,
  }
}

export function formatShortDateTime(value: string | null | undefined): string {
  if (!value) return '-'

  const date = parseApiDateTime(value)
  if (!date) return '-'

  const parts = getDateTimeParts(date, DEFAULT_TIME_ZONE)
  return `${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-'

  const date = parseApiDateTime(value)
  if (!date) return '-'

  const parts = getDateTimeParts(date, DEFAULT_TIME_ZONE)
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}

export const formatMessageTime = formatShortDateTime
export const formatMessageDateTime = formatDateTime
